// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__2xhku","description":"MealItem_description__kCCYP","price":"MealItem_price__1t0ut"};